import { render, staticRenderFns } from "./TicketIssued.vue?vue&type=template&id=3968f965"
import script from "./TicketIssued.vue?vue&type=script&lang=js"
export * from "./TicketIssued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports